// extracted by mini-css-extract-plugin
export var bubble = "troll-module--bubble--TmIby";
export var speech = "troll-module--speech--6I4sn";
export var trollContainer = "troll-module--trollContainer--BNB26";
export var trollImage = "troll-module--trollImage--ZQc0w";